import Modal from 'modal-vanilla/dist/modal';

export class JobOfferLayout {

  _applyForJobButtonEl;
  _applyForJobModalInstance;
  _applyForJobModal;

  init() {
    this._applyForJobButtonEl = document.querySelector('#apply-for-job-button');
    this._applyForJobModal = document.querySelector('#apply-for-job-modal');

    if (this._applyForJobButtonEl && this._applyForJobModal) {
      this.afterComponentRender();
    }
  }

  afterComponentRender() {
    this.openApplyForJobModal();
  }

  openApplyForJobModal() {
    this._applyForJobButtonEl.addEventListener('click', () => {
      this._applyForJobModalInstance = new Modal({
        el: this._applyForJobModal
      }).show();
    });
  }
}
